import { create } from 'zustand'
import { Notification } from '../types/notification'
import { notificationApi } from '../api/notification'

interface NotificationStore {
  notifications: Notification[]
  isLoading: boolean
  loadNotifications: () => Promise<void>
  markAsRead: (id: string) => Promise<void>
  markAllAsRead: () => Promise<void>
  getUnreadCount: () => number
  addNotification: (notification: Notification) => void
  updateNotification: (id: string, updates: Partial<Notification>) => void
}

export const useNotificationStore = create<NotificationStore>((set, get) => ({
  notifications: [],
  isLoading: false,

  loadNotifications: async () => {
    set({ isLoading: true })
    try {
      const response = await notificationApi.getNotifications()
      set({ notifications: response.notifications })
    } catch (error) {
      console.error('알림 목록 로드 실패:', error)
    } finally {
      set({ isLoading: false })
    }
  },

  markAsRead: async (id: string) => {
    const notification = get().notifications.find((n) => n.id === id)
    if (!notification || notification.isRead) {
      return
    }

    try {
      await notificationApi.markAsRead(id)
      set((state) => ({
        notifications: state.notifications.map((n) =>
          n.id === id ? { ...n, isRead: true } : n
        ),
      }))
    } catch (error) {
      console.error('알림 읽음 처리 실패:', error)
    }
  },

  getUnreadCount: () => {
    return get().notifications.filter((n) => !n.isRead).length
  },

  markAllAsRead: async () => {
    const hasUnread = get().notifications.some((n) => !n.isRead)
    if (!hasUnread) return

    try {
      await notificationApi.markAllAsRead()
      set((state) => ({
        notifications: state.notifications.map((n) => ({ ...n, isRead: true })),
      }))
    } catch (error) {
      console.error('알림 일괄 읽음 처리 실패:', error)
    }
  },

  addNotification: (notification: Notification) => {
    set((state) => ({
      notifications: [notification, ...state.notifications],
    }))
  },

  updateNotification: (id: string, updates: Partial<Notification>) => {
    set((state) => ({
      notifications: state.notifications.map((n) =>
        n.id === id ? { ...n, ...updates } : n
      ),
    }))
  },
}))
